import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

const SocialProofStats = ({ language }) => {

  const lang = language === "CN" ? "zh" : "en";

  const content = {
    en: {
      subtitle: "SOCIAL PROOF / STATS",
      title: "The Numbers Behind the Trust",
      stats: [
        {
          number: 30,
          suffix: "+",
          title: "Years in Service",
          desc: "Serving Singaporeans since 1996, through every market cycle and life stage.",
        },
        {
          number: 3000,
          suffix: "+",
          title: "Client Cases Per Year",
          desc: "One of the most active advisory teams under AIA Singapore.",
        },
        {
          number: 11.7,
          prefix: "S$",
          suffix: "M+",
          title: "Assets Under Management",
          desc: "Trusted to manage and grow the wealth of individuals, families, and businesses.",
        },
        {
          number: 60,
          suffix: "+",
          title: "Dedicated Professionals",
          desc: "A growing team of advisors, mentors, and leaders.",
        },
        {
          number: 2025,
          prefix: "2012-",
          title: "MDRT Group Recognition",
          desc: "Consistent top-tier performance recognised at the highest industry level.",
          noComma: true,
        },
      ],
    },

    zh: {
      subtitle: "实力证明 / 数据",
      title: "信任背后的数字",
      stats: [
        {
          number: 30,
          suffix: "+",
          title: "服务年限",
          desc: "自 1996 年以来服务新加坡客户。",
        },
        {
          number: 3000,
          suffix: "+",
          title: "每年客户案例",
          desc: "AIA 新加坡最活跃团队之一。",
        },
        {
          number: 11.7,
          prefix: "S$",
          suffix: "M+",
          title: "管理资产",
          desc: "受客户信任管理财富。",
        },
        {
          number: 60,
          suffix: "+",
          title: "专业团队",
          desc: "不断成长的顾问团队。",
        },
        {
          number: 2025,
          prefix: "2012-",
          title: "MDRT 荣誉",
          desc: "持续获得行业认可。",
          noComma: true,
        },
      ],
    },
  };

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = content[lang].stats;

  return (
    <section className="bg-white py-10">

      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">


        {/* Heading */}
        <div className="text-center mb-10">

          <p className="text-[#C69C6D] font-semibold tracking-wide mb-4">
            {content[lang].subtitle}
          </p>

          <h2 className="text-3xl md:text-4xl font-medium text-[#154059]">
            {content[lang].title}
          </h2>

        </div>



        {/* MOBILE (STATIC NUMBER) */}
        <div className="md:hidden overflow-hidden">

          <Swiper
            key={lang}
            modules={[Autoplay]}
            spaceBetween={15}
            slidesPerView={1}
            autoplay={{ delay: 2500 }}
            observer={true}
            observeParents={true}
            updateOnWindowResize={true}
          >

            {stats.map((item, index) => (

              <SwiperSlide key={index}>

                <div className="bg-white rounded-xl border border-[#C69C6D] shadow-lg px-5 py-8 text-center min-h-[230px] flex flex-col justify-between">

                  <h3 className="text-3xl font-semibold text-[#C69C6D] mb-3">

                    {item.prefix}
                    {item.number}
                    {item.suffix}

                  </h3>

                  <h4 className="text-lg font-semibold text-[#154059] mb-3">
                    {item.title}
                  </h4>

                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>

                </div>

              </SwiperSlide>

            ))}

          </Swiper>

        </div>



        {/* DESKTOP (COUNTUP) */}
        <div
          ref={ref}
          className="hidden md:grid md:grid-cols-2 lg:grid-cols-5 bg-white rounded-2xl border border-[#C69C6D] shadow-[0_15px_40px_rgba(0,0,0,0.06)]"
        >

          {stats.map((item, index) => (

            <div key={index} className="text-center px-10 py-10 relative">

              {index !== stats.length - 1 && (
                <span className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 w-[1px] h-[100px] bg-[#C69C6D]/50"></span>
              )}

              <h3 className="text-3xl font-semibold text-[#C69C6D] mb-3">

                {item.prefix}

                {inView && (
                  <CountUp
                    start={0}
                    end={item.number}
                    duration={1.6}
                    separator={item.noComma ? "" : ","}
                    decimals={item.number % 1 !== 0 ? 1 : 0}
                  />
                )}

                {item.suffix}

              </h3>

              <h4 className="text-lg font-semibold text-[#154059] mb-3">
                {item.title}
              </h4>

              <p className="text-gray-600 text-sm leading-relaxed max-w-[220px] mx-auto">
                {item.desc}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default SocialProofStats;